// components/layout/SiteFooter.tsx
import { profileState } from "@/atoms/profile";
import { Button } from "@/components/ui/button";
import { useLoadReceipts } from "@/hooks/useLoadReceipts";
import { To, useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { triggerHapticFeedback } from "@/utils/hapticFeedback";
// import DrawerComponent from "../AddFooterButton";

import {
  // Calculator,
  CheckFat,
  ClockCounterClockwise,
  // ListChecks,
  // Money,
  MoneyWavy,
  Plus,
  // Receipt,
  Trophy,
} from "@phosphor-icons/react";

export function SiteFooter() {
  const [profile] = useRecoilState(profileState);
  const location = useLocation();
  const navigate = useNavigate();

  useLoadReceipts();

  if (!profile) {
    return null;
  }

  const handleNavigation = async (path: To) => {
    triggerHapticFeedback(); // trigger haptic feedback
    navigate(path);
  };

  return (
    <footer className="fixed bottom-0 z-50 w-full bg-[#1a1a2e]">
      <div className="container px-6 lg:px-8 mx-auto flex h-16 max-w-screen-sm items-center justify-between">
        <div
          onClick={() => handleNavigation("/")}
          className="flex flex-col items-center mr-2 cursor-pointer"
        >
          <CheckFat
            size={30}
            className={`${location.pathname === "/" ? "text-blue-500" : "text-white/80"}`}
          />
          {/* <span className="text-white text-xs mt-1">Profile</span> */}
        </div>
        <div
          // onClick={() => handleNavigation("/points")}
          onClick={() => handleNavigation("/leaderboard")}
          className="flex flex-col items-center cursor-pointer"
        >
          <Trophy
            size={30}
            className={`${location.pathname?.startsWith("/leaderboard") ? "text-blue-500" : "text-white"}`}
          />
          {/* <span className="text-white text-xs mt-1">Statistics</span> */}
        </div>
        <div className="relative flex justify-center items-center w-8">
          <Button
            className="
              flex justify-center items-center 
              bg-blue-500 hover:bg-blue-400 
              rounded-full border-8 border-[#01081B]
              h-20 w-20 -mt-12 mr-2"
            onClick={() => handleNavigation("/transaction/new")}
          >
            <Plus className="text-white" size="30" />
          </Button>
        </div>
        <div
          onClick={() => handleNavigation("/timeline")}
          className="flex flex-col items-center cursor-pointer"
        >
          <ClockCounterClockwise
            size={30}
            className={`${location.pathname.startsWith("/timeline") ? "text-blue-500" : "text-white"}`}
          />
          {/* <span className="text-white text-xs mt-1">Budget</span> */}
        </div>
        <div
          onClick={() => handleNavigation("/dashboard")}
          className="flex flex-col items-center ml-2 cursor-pointer"
        >
          <MoneyWavy
            size={30}
            className={`${location.pathname === "/dashboard" ? "text-blue-500" : "text-white"}`}
          />
          {/* <span className="text-white text-xs mt-1">Dashboard</span> */}
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;
